"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var actions_1 = require("../../store/challenges/actions");
var ChallengesListener = (function () {
    function ChallengesListener() {
    }
    ChallengesListener.listen = function (store) {
        document.getElementById('defaultChallenge').classList.add('active');
        store.dispatch(actions_1.setChallenge({
            nomber: 1
        }));
        var challengeElems = document.querySelectorAll('.ctrl-no-of-chalenges');
        Array.from(challengeElems).forEach(function (element) {
            element.addEventListener('click', function () {
                Array.from(challengeElems).forEach(function (element) {
                    if (element.classList.contains('active')) {
                        store.dispatch(actions_1.resetChallenge());
                        element.classList.remove('active');
                    }
                });
                store.dispatch(actions_1.setChallenge({
                    nomber: Number(element.children[0].innerHTML)
                }));
                element.classList.add('active');
            });
        });
    };
    return ChallengesListener;
}());
exports.default = ChallengesListener;



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/listeners/betting/challneges.ts
// module id = 2398
// module chunks = 5